import { useState } from 'react';

export interface UseSiteSearchTermResult {
  searchTerm: string;
  activeQuery: string;
  isSearching: boolean;
  handleSearchChange: (newSearchTerm: string) => void;
}

// A 3+ character (trimmed) query enters "search mode" (activeQuery set); a fully-cleared query
// exits it; 1-2 characters is a deliberate no-op so a transient backspace mid-search doesn't drop
// a confirmed search's results.
export function useSiteSearchTerm(): UseSiteSearchTermResult {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeQuery, setActiveQuery] = useState('');

  const handleSearchChange = (newSearchTerm: string) => {
    setSearchTerm(newSearchTerm);
    const trimmed = newSearchTerm.trim();
    if (trimmed.length >= 3) {
      setActiveQuery(trimmed);
    } else if (trimmed.length === 0) {
      setActiveQuery('');
    }
  };

  return { searchTerm, activeQuery, isSearching: activeQuery.length > 0, handleSearchChange };
}
